/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Step1_LinkInputs */

const en_serve_step1_link = /** @type {(inputs: Serve_Step1_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Node.js`)
};

const id_serve_step1_link = /** @type {(inputs: Serve_Step1_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh Node.js`)
};

/**
* | output |
* | --- |
* | "Download Node.js" |
*
* @param {Serve_Step1_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_step1_link = /** @type {((inputs?: Serve_Step1_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Step1_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_step1_link(inputs)
	return en_serve_step1_link(inputs)
});